import { render, staticRenderFns } from "./NewsBannerList.vue?vue&type=template&id=0b563c98&"
import script from "./NewsBannerList.vue?vue&type=script&lang=js&"
export * from "./NewsBannerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports